import type React from 'react';

import { StaffDrawer, StaffDrawerInfo, StaffDrawerLink, StaffDrawerSection } from '#src/app/shared/components/staff';

import { usePetitionStaffDrawer } from './hooks/usePetitionStaffDrawer';

export const PetitionStaffDrawer: React.FC<EmptyProps> = () => {
	const {
		data: { petitionId, status, discoverable, promotable, starterId, urls },
	} = usePetitionStaffDrawer();

	return (
		<StaffDrawer>
			<StaffDrawerSection title="Petition">
				<StaffDrawerInfo label="Petition ID" value={petitionId} copyable />
				<StaffDrawerInfo label="Status" value={status} />
				<StaffDrawerInfo label="Discoverable" value={discoverable} />
				<StaffDrawerInfo label="Promotable" value={promotable} />
				<StaffDrawerLink href={urls.petitionAdmin}>Petition admin</StaffDrawerLink>
				<StaffDrawerLink href={urls.editTags}>Edit tags</StaffDrawerLink>
				<StaffDrawerLink href={urls.promotionSettings}>Promotion settings</StaffDrawerLink>
				<StaffDrawerLink href={urls.victory}>Victory</StaffDrawerLink>
			</StaffDrawerSection>
			<StaffDrawerSection title="Starter">
				<StaffDrawerInfo label="User ID" value={starterId} copyable />
				<StaffDrawerLink href={urls.userAdmin}>User admin</StaffDrawerLink>
			</StaffDrawerSection>
			<StaffDrawerSection title="Starter tools">
				<StaffDrawerLink href={urls.dashboard}>Dashboard</StaffDrawerLink>
				<StaffDrawerLink href={urls.edit}>Edit petition</StaffDrawerLink>
			</StaffDrawerSection>
			{urls.movementAdmin && (
				<StaffDrawerSection title="Movement">
					<StaffDrawerLink href={urls.movementAdmin}>Movement admin</StaffDrawerLink>
				</StaffDrawerSection>
			)}
		</StaffDrawer>
	);
};
